import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Ensures URLs have properly encoded path segments.
 * Fixes broken URLs with unencoded spaces or special characters.
 * Handles both new (encoded) and old (unencoded) URLs for backward compatibility.
 */
export function ensureEncodedUrl(url: string): string {
  if (!url) return '';
  try {
    const urlObj = new URL(url);
    // Re-encode path segments to fix spaces and special characters
    const pathParts = urlObj.pathname.split('/');
    urlObj.pathname = pathParts.map(part => 
      encodeURIComponent(decodeURIComponent(part))
    ).join('/');
    return urlObj.toString();
  } catch {
    // Fallback: simple space replacement
    return url.replace(/ /g, '%20');
  }
}
